<h1 class="text-5xl font-medium text-center mb-4 mt-4"><span class="text-orange-gradient">Homey</span> is launching soon!</h1>
<p class="text-center text-lg mb-10">Enter your email to enter our waiting list.</p>
<form>
<div class="flex flex-row w-full gap-2">
<homey-text-input label="Enter your email address" inputId="email" type="email" [inputFormControl]="emailFormControl" class="flex-grow"></homey-text-input>
  <homey-submit-button [dt]="dt" submitButtonLabel="Submit" [submitFunction]="submitFunction"/>
</div>
</form>
